export const AUTH_DISABLED = import.meta.env.VITE_DISABLE_AUTH === "true";

export const oidcConfig = {
  authority: "https://app-carbonite-sso-us-prod-stage.azurewebsites.net",
  client_id: import.meta.env.VITE_CLIENT,
  redirect_uri: globalThis.location.origin + "/signin-callback",
  post_logout_redirect_uri: globalThis.location.origin,
  response_type: "code",
  scope: "openid profile email",
  // Enable PKCE for security
  automaticSilentRenew: true,
  loadUserInfo: true,
};
